<script>
import env from '@root/env';
import BOGen from '@helper/BOGen';
import Gen from '@helper/Gen';
import BoConfig from '@config/BoConfig';

export default {
  computed:{
		baseUrl(){ return env.baseUrl },
		user(){ return this.$root.user },
		fields(){ return this.$root.fields },
		web(){ return this.$root.web },
		app(){ return this.$root.app },
    page(){ return this.$root.page },
    loadingOverlay:{
      get(){ return this.$root.var.loadingOverlay },
      set(v){ return this.$root.var.loadingOverlay = v },
    },
    preloader:{
      get(){ return this.$root.var.preloader },
      set(v){ return this.$root.var.preloader = v },
    },
    isMobile(){
      return this.$root.width < 768
    },
    moment(){ return global.moment },
    isServicesRole(){
      return BoConfig.mrServicesRole.concat(BoConfig.mrHRServices).filter(v=>{ return this.isModule(v) })[0] ? true : false
    },
    BoConfig(){
      return BoConfig
    },
    isLockAuthorization(){
      try{
        var start = new moment(this.$root.var.lockAuthorization.startdate, "DD-MM-YYYY");
        var end = new moment(this.$root.var.lockAuthorization.enddate, "DD-MM-YYYY");
        return start.isBefore() && end.isAfter() && this.$root.var.lockAuthorization.lock
      }catch{
        return false
      }
    },
  },
  methods:{
    assets(type, filename) {
      return env.baseUrl + "/" + type + (filename ? "/" + filename : "" );
    },
    uploader(filename, size) {
      var sizePath = size ? "/img/"+size+"/" : "/uploader/";
      return env.baseUrl + sizePath + (filename ? filename : "");
    },
    refreshVariable(){
      var variable = Gen.getCookie("variable", {});
      Object.keys(variable).forEach((k)=>{
        this.$set(this.$root.var, k, variable[k])
      })
      BOGen.apirest("/variable", {}, (err, resp)=>{
        if(err) return;
        Gen.putCookie("variable", resp)
        Object.keys(resp).forEach((k)=>{
          this.$set(this.$root.var, k, resp[k])
        })
      })
    },
    readyVariable(callback){
      var iN = setInterval(()=>{
        if(global.variableLoaded){
          clearInterval(iN)
          callback()
        }
      }, 50)
    },
    LoadingOverlay(params = {}){
      return this.$loading.show(params);
    },
    /* Form Validation */
    validation(name){
      if(!this.mrValidation[name]) return {}
      var validation = {}
      this.mrValidation[name].split("|").forEach((v)=>{
        var x = v.split(":")
        validation[x[0]] = x[1] || true
        if(x[0]=="min") validation["minlength"] = x[1]
        if(x[0]=="max") validation["maxlength"] = x[1]
      })
      return validation
    },
    // User Role
    isMenu(menu){ return this.user.al_access_menu.indexOf(menu) > -1 },
    isModule(module){
      if(Array.isArray(module)){
        var access = false
        module.forEach(v=>{ if(this.isModule(v)) access = true })
        return access
      }
      return this.user.al_access_module.indexOf(module) > -1
    },
    back(){
      if(history.length<=1) return window.close()
      history.back()
    },
    checkAccessMenu(menu){
      if(this.user.al_access_menu.indexOf(menu) < 0) return this.$router.push({ name: "Dashboard" })      
    }
  }
}
</script>
